import { ref, set } from '@vue/composition-api';

const checkResultStore = ref({});

// aco存储url中的建议
export function useCheckURLStore() {
  function checkTitleStoreSet(key: string, val: any) {
    set(checkResultStore.value, key, val);
  }

  function checkURLStoreGet(key: string) {
    return checkResultStore.value[key];
  }

  return { checkTitleStoreSet, checkURLStoreGet };
}
